<template>
    <ais-refinement-list
        :attribute="attribute"
        :limit="limit"
        :sort-by="sortBy"
        class="refinement-list"
    >
        <template v-slot="{ items, refine }">
            <div :class="listClass" v-if="items.length > 0">
                <div class="header" @click="toggle">{{ attributeHeader }}</div>
                <div class="content">

                    <div>
                        <ul class="ais-RefinementList-list">
                            <li v-for="item in items" :key="item.value" class="ais-RefinementList-item">
                                <label
                                    class="ais-RefinementList-label"
                                    @click.prevent="refine(item.value)"
                                >
                                    <input type="checkbox" class="ais-RefinementList-checkbox" :checked="item.isRefined" :value="item.value">
                                    <span class="ais-RefinementList-labelText"> {{ item.label }}</span>
                                    <span class="ais-RefinementList-count">{{ item.count }}</span>
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </template>
    </ais-refinement-list>
</template>

<script>
export default {
    data: () => ({
        active: true,
    }),
    computed: {
        listClass() {
            if (this.stayOpen) {
                return ['open', 'hide-toggle'];
            }
            return (this.active) ? 'open' : 'close';
        },
        attributeHeader() {
            return this.attribute
                .replace(/([A-Z])/g, ' $1')
                .replace(/-/g, ' ')
                .split(' ')
                .map(w => w.charAt(0).toUpperCase() + w.slice(1))
                .join(' ');
        },
    },
    methods: {
        toggle() {
            this.active = !this.active;
        }
    },

    props: ['stayOpen', 'attribute', 'limit', 'sortBy']
}
</script>
